import moment from "moment";
import CustomInput from "@/components/shared/CustomInput";
import CustomTimePicker from "@/components/shared/CustomTimePicker";
import CustomSelect from "@/components/shared/CustomSelect";
import DashboardConstants from "@/store/constants/dashboardRecords";
import TrashIcon from "@/components/shared/TrashIcon"
import DashboardInternalData from "@/internalData/Dashboard"
import GlobalConstants from "@/store/constants/global"

export default {
  name: "InspectionsRecordsTable",
  components: {
    CustomInput,
    CustomTimePicker,
    CustomSelect,
    TrashIcon
  },
  data() {
    return {
      inProcessFields: DashboardInternalData.inspectionRecords.inProcessFields,
      resultSelections: [
        { key: null, value: "" },
        { key: 'no', value: this.$t("inspectionsTable.resultSelections.resultTrue") },
        { key: 'yes', value: this.$t("inspectionsTable.resultSelections.resultFalse") },
      ],
      informedSelections: [
        { key: null, value: "" },
        { key: 'no', value: '〇' },
        { key: 'yes', value: '✕' }
      ]
    };
  },
  methods: {
    getTwentyFourHours(dtime) {
      let formatDate = new moment(dtime);
      return formatDate.format("HH:mm");
    },
    showConfirmModal(orderId) {
      this.$bvModal.show('confirm-modal');
      this.$store.commit(GlobalConstants.COMMIT.setConfirmAttr, { attr: "inspections", orderId: orderId });
    },
    inputPoint(attr, value, index) {
      let path = ["inspections", index, attr];
      this.$store.commit(DashboardConstants.COMMIT.setValueRecord, { path: path, value: value });
      //recalculate revision
      const elementsNeedRecalculateRevision = ["result", "informed", "time"]
      elementsNeedRecalculateRevision.includes(attr) && this.$store.commit(DashboardConstants.COMMIT.recalculateRevision);
    },
    addNewLineInpirations() {
      this.$store.commit(DashboardConstants.COMMIT.addNewRecord, "inspections");
    },
    handleFocusLine(subAttr, index, status) {
      //handle lost focus
      let obj = { attr: "inspections", index: index, subAttr: subAttr, status: status };
      this.$store.commit(DashboardConstants.COMMIT.changeStatusFocus, obj);
      //recalculate revision
      !status && this.$store.commit(DashboardConstants.COMMIT.recalculateRevision);
    },
  },
  computed: {
    statusEditable() {
      return this.$store.getters[DashboardConstants.GETTERS.getStatusEditable];
    },
    diaryPrevious() {
      let inspectionRecord = this.$store.getters[DashboardConstants.GETTERS.getDiaryRevisions].inspections;
      return inspectionRecord;
    },
  }
};